import clsx from "clsx";
import style from "./AnalogTransition.module.scss";

export interface Transition {
  queueIndex: string;
  char: string;
  previousChar: string;
}

export default function AnalogTransition({
  character,
  previousCharacter,
  onComplete,
}: {
  character: number | string;
  previousCharacter: number | string;
  onComplete: () => void;
  percent?: number;
}) {
  // NOTE: time here refers to the animation-duration found in the shared.module.scss
  setTimeout(() => {
    onComplete();
  }, 900);

  // whole card behind
  const bottomHalfofNumber = () => (
    <div className={clsx(style.numberContainer, style.fullRadius)}>
      <div className={style.number}>{previousCharacter}</div>
      <div className={style.shading} />
    </div>
  );

  const bottomHalfofTransitionNumber = () => (
    <div className={clsx(style.numberContainer, style.bottomRadius)}>
      <div className={clsx(style.number, style.bottomHalfofTransitionNumber)}>
        {character}
      </div>
    </div>
  );

  // top behind during transtion
  const topHalfofNumber = () => (
    <div className={clsx(style.topHalf, style.half, style.topRadius)}>
      <div className={clsx(style.numberContainer)}>
        <div className={style.number}>{character}</div>
      </div>
    </div>
  );

  // top while stationary and front during transition
  const topHalfofTransitionNumber = () => (
    <div
      className={clsx(style.numberContainer, style.backside, style.topRadius)}
    >
      <div className={style.number}>{previousCharacter}</div>
      <div className={style.shading} />
    </div>
  );

  return (
    <div className={style.container} aria-hidden="true">
      {topHalfofNumber()}
      <div className={style.spacer}>
        <div className={style.spacerShade} />
      </div>
      {bottomHalfofNumber()}
      <div className={clsx(style.transition, style.half, style.fullRadius)}>
        {bottomHalfofTransitionNumber()}
        {topHalfofTransitionNumber()}
      </div>
    </div>
  );
}
